export default function mapForecastResponse(response) {
	const items = response?.data || [];
	const count = response?.count;
	const quoteCardsInfo = response?.quote_cards_info;
	const yearCardInfo = response?.yearly_quote_card_info?.[0];

	return {
		items: items.map((item) => {
			return {
				...item,
				thumbnail: item?.imagen,
			};
		}),
		count,
		quoteCardsInfo,
		yearCardInfo,
	};
}
